import React from "react";
import { redirect, useRouteLoaderData } from "react-router-dom";
import TabLayout from "../../helpers/TabLayout";
import EmailsTable from "./EmailsTable";
import { testSessionLoader } from "../../../loaders/helpers";
import { userEmailList } from "../../../api/useremail";

const emailsTabLoader = async (params) => {
  await testSessionLoader(params);
  const url = new URL(params.request.url);
  let page = Number(url.searchParams.get("page"));
  page = isNaN(page) ? 0 : page;
  const emailsListRes = await userEmailList(page);
  const emails = emailsListRes.data;
  if (!emails.length && page !== 0) throw redirect("?page=0");
  return { emailsList: emails, page };
};

const EmailsTab = () => {
  const { emailsList } = useRouteLoaderData("adminUserEmails");
  let { page } = useRouteLoaderData("adminUserEmails");

  const onPageButtonClicked = (newPage) => page = newPage;

  return (
    <>
      <TabLayout
        headerLabel="Emails"
        skeletonLines={16}
      >
        <EmailsTable
          emailsList={emailsList}
          currentPage={page}
          onPageButtonClicked={onPageButtonClicked}
        />
      </TabLayout>
    </>
  );
};

export { emailsTabLoader };
export default EmailsTab;